import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { CodeV2, api } from './generated';

export const updateCode = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  slug: string,
  data: CodeV2
) => {
  dispatch(
    api.util.updateQueryData('getV2QrCodesBySlug', { slug }, (draft) => {
      Object.assign(draft, data);
    })
  );
};
